import { useAuth } from '@verantos-dev/core-auth';

import { useAdRouteParams } from './useAdRouteParams';
import { useAnalyticalDatasetProfileQuery } from '../api/useAnalyticalDatasetProfileQuery';
import type { UseAnalyticalDatasetEditLockResult } from '../types';

// Single edit-lock gate for the analytical dataset definition, mirroring cohort
// builder's view-mode (`!isEditable || isProcessing`). Editing — add/replace/
// delete cohort + variables, and re-processing — is locked when:
//   - the current user isn't the dataset owner (created it), or
//   - the latest run is in flight (PROCESSING).
// Locked-until-known: while the profile is still loading, `isOwner` is false so
// affordances stay disabled (matches cohort, whose store defaults isEditable).
export const useAnalyticalDatasetEditLock = (): UseAnalyticalDatasetEditLockResult => {
  const {
    user: { auth0Id, userId },
  } = useAuth();
  const { projectId, analyticalDatasetProfileId } = useAdRouteParams();
  const { data } = useAnalyticalDatasetProfileQuery({ projectId, analyticalDatasetProfileId });
  const profile = data?.data;

  const isProcessing = profile?.latestStatus === 'PROCESSING';
  const ownerUserId = profile?.createdBy?.userId;
  const isOwner = !!ownerUserId && [auth0Id, userId].includes(ownerUserId);

  return { isEditDisabled: !isOwner || isProcessing, isProcessing, isOwner };
};
